module.exports = {
  "/:contentType/:contentId": {
    "success": {
      "composer editor": [
        "COMPOSER_LOADED"
      ]
    }
  }
};